import React from 'react'

export default ({ width, height }) => (
  <svg
    width={width || '26'}
    height={height || '22'}
    viewBox="0 0 26 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.884 3.438c-.932.36-1.864.646-2.94.79 1.076-.646 1.793-1.65 2.295-2.798-1.005.502-2.153 1.004-3.372 1.22C20.008 1.644 18.718 1 17.21 1c-2.796 0-5.09 2.295-5.09 5.163 0 .36.07.79.143 1.148C7.96 7.097 4.303 5.09 1.72 1.933c-.43.79-.644 1.65-.644 2.582 0 1.793.79 3.37 2.223 4.23-.862 0-1.65-.214-2.296-.573v.073c0 2.438 1.72 4.518 4.016 5.02-.36.07-.79.143-1.363.143-.287 0-.573-.072-.86-.143.573 2.008 2.438 3.514 4.733 3.585C5.81 18.21 3.586 19 1.22 19H0c2.223 1.434 4.948 2.294 7.817 2.294 9.394 0 14.485-7.744 14.485-14.557v-.645c1.004-.718 1.937-1.722 2.582-2.654z"
      stroke="#454545"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/twitterIcon.js